// @ts-nocheck -- Build nélküli, kézzel írt plain JS sziget; a repo checkJs típusellenőrzését szándékosan kihagyjuk (lásd CLAUDE.md).
/*
 * Build nélküli, plain böngésző-JS (globális adat). A repo oxlint konfigja a
 * TS+build világra van hangolva, ami erre a szigetre nem alkalmazható és valódi
 * hibát nem fog. Ezért kikapcsoljuk; build esetén TS-re konvertálandó. Lásd README.
 */
/* oxlint-disable */

/**
 * TudásFM – kiemelt YouTube videók.
 *
 * A landing alján megjelenő „legnézettebb videók" blokk adata. A tömb
 * SORRENDJE a megjelenítés sorrendje. Egy elem szerkezete:
 *   {
 *     id:    a YouTube videó azonosítója (a watch?v= utáni rész),
 *     title: a kártyán megjelenő cím (string)
 *   }
 *
 * A thumbnailt a js/youtube.js közvetlenül az ID-ből képzi
 * (https://i.ytimg.com/vi/<id>/…jpg), így nincs szükség API-kulcsra vagy
 * hálózati lekérésre a betöltéshez. Klasszikus <script>-ként töltjük be
 * (globális változó), hogy `file://` protokollon is működjön.
 */
window.TUDASFM_YOUTUBE = [
  { id: 'nGOn7h3-AfU', title: 'Cooltúra – Mucsi Zoltán interjú' },
  { id: 'qAUH7kX1sSY', title: 'AkkezdeathMetal – Subscribe & Akkezdet Phiai interjú' },
  { id: 'zIF0Om2KPBg', title: 'The Carbonfools – Carbonsweet lemezbemutató, A38' },
];
